
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic15Off as ObiHydraulic15OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-15-off.js';
 
 
 

 
 export const ObiHydraulic15Off = createComponent({
   react: React,
   tagName: 'obi-hydraulic-15-off',
   elementClass: ObiHydraulic15OffElement,
   events: {
     
   }
  });
 
 